module.exports = __webpack_public_path__ + "img/iconTal.3fbdc01d.png";